import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { CATEGORIES } from '@/mocks/categories';

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative w-full" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between gap-3 rounded-lg border border-background-300/70 bg-background-50 px-4 py-3 text-left text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100 cursor-pointer"
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span className="flex items-center gap-2">
          <i className="ri-price-tag-3-line text-primary-600" />
          {t('category.dropdown_placeholder')}
        </span>
        <i
          className={`ri-arrow-down-s-line text-foreground-500 transition-transform ${
            open ? 'rotate-180' : ''
          }`}
        />
      </button>

      {open && (
        <div className="absolute left-0 right-0 z-30 mt-2 max-h-80 overflow-y-auto rounded-lg border border-background-300/70 bg-background-50 py-1 shadow-sm">
          {CATEGORIES.map((cat) => (
            <a
              key={cat.key}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              onClick={() => setOpen(false)}
              className="flex items-center gap-2.5 px-4 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-background-100 cursor-pointer"
            >
              <span className="flex h-6 w-6 items-center justify-center text-primary-600">
                <i className={cat.icon} />
              </span>
              <span className="whitespace-nowrap">{t(`cat.${cat.key}`)}</span>
              <i className="ri-arrow-right-up-line ml-auto text-foreground-400" />
            </a>
          ))}
        </div>
      )}
    </div>
  );
}